import styled from '@emotion/styled';

import { useInView } from 'react-intersection-observer';

import { useEffect } from 'react';

import { AcceptedProduct } from '../../types';

import InformationContents from '../components/description/InformationContents';

import ProductNotice from '../components/description/product-notice/ProductNotice';
import SellerNotice from '../components/description/product-notice/SellerNotice';
import WhyKurly from '../components/description/WhyKurly';
import HappyCenter from '../components/description/HappyCenter';
import Faq from '../components/description/faq/Faq';
import DeliveryNotice from '../components/description/DeliveryNotice';
import ProductReviewContainer from '../../../board/review/pc/ProductReviewContainer';
import ProductInquiryBoardContainer from '../../../board/inquiry/pc/ProductInquiryBoardContainer';
import EventBanner from '../components/description/EventBanner';
import ProductDetailImage from '../components/description/ProductDetailImage';
import GiftDeliveryNotice from '../../shared/GiftDeliveryNotice';
import PartnerDescription from '../../shared/PartnerDescription';

const Container = styled.div``;

const ContentsWrapper = styled.div`
  position: relative;
  width: 1010px;
  padding-bottom: 100px;

  :first-of-type {
    padding-top: 40px;
  }
`;

interface Props {
  product: AcceptedProduct;
  handleInView(show: boolean): void;
}

export default function DescriptionContainer({ product, handleInView }: Props) {
  const { ref, inView } = useInView({ threshold: 0.01 });

  const {
    no,
    name,
    mainImageUrl,
    productNotice,
    sellerNotice,
    isGiftable,
    isThirdPart,
    productDetail: { content, legacyContent, legacyPiImages, legacyEventBanner },
    isInquiryWritable,
    isReviewWritable,
  } = product;

  useEffect(() => {
    handleInView(inView);
  }, [handleInView, inView]);

  return (
    <Container ref={ref}>
      <ContentsWrapper id="description">
        {isGiftable && <GiftDeliveryNotice />}
        {legacyEventBanner && <EventBanner eventBanner={legacyEventBanner} />}
        <InformationContents legacyContent={legacyContent ?? ''} />
        <PartnerDescription partnerContent={content} />
      </ContentsWrapper>
      <ContentsWrapper id="detail">
        <ProductDetailImage detailImages={legacyPiImages} />
        <ProductNotice productNotice={productNotice} />
        <SellerNotice sellerNotice={sellerNotice} isThirdPart={isThirdPart} />
        <WhyKurly />
        <HappyCenter />
        <Faq />
        <DeliveryNotice />
      </ContentsWrapper>
      {isReviewWritable && (
        <ContentsWrapper id="review">
          <ProductReviewContainer contentsProductNo={no} />
        </ContentsWrapper>
      )}
      {isInquiryWritable && (
        <ContentsWrapper id="inquiry">
          <ProductInquiryBoardContainer no={no} name={name} mainImageUrl={mainImageUrl} />
        </ContentsWrapper>
      )}
    </Container>
  );
}
